import Axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

const JudgeCityPage = () => {
  const params = useParams();
  const { city } = params;
  const [competitions, setCompetitions] = useState([]);
  const navigate = useNavigate();

  const fetchAllCompetitions = () => {
    Axios.get(`https://ashish.moodi.org/multicity/get_mul_compi?city=${city}`)
      .then((res) => setCompetitions(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (localStorage.getItem("judgeauthtoken")) {
      fetchAllCompetitions();
    } else {
      navigate("/judge/login");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container-fluid">
      <h2 className="title">{city} - Select Competition to Judge</h2>
      <ul>
        {competitions.map((competition) => {
          return (
            <li>
              <Link to={`/judge/multicity/competition/${competition.mcId}`}>
                {competition.mcName}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default JudgeCityPage;
